<template>
  <div class="flex flex-col gap-[40px]">
    <section class="flex flex-col">
      <p class="text-grays-900 text-base font-bold">לא קיבלתם?</p>
      <div class="text-grays-900 text-base font-regular">
        <p v-if="isResendDisabled && !isLoading">
          <span class="font-semibold">נסו שוב בעוד {{ timer }}s</span>
        </p>
        <button
            v-if="!isResendDisabled && !isLoading"
            :disabled="isResendDisabled"
            class="text-grays-600 font-bold underline cursor-pointer disabled:cursor-not-allowed"
            @click="submit"
        >
          תשלחו לי מייל
        </button>
      </div>
      <p v-if="isLoading" class="text-grays-900 text-base font-regular">
        טוען נתונים...
      </p>
    </section>
    <error-block
        v-if="requestError.show && !requestSuccess"
        :errorMessage="requestError.message"
    />
    <success-block
        v-if="requestSuccess && !requestError.show"
        :message="'האימייל נשלח שוב'"
    />
  </div>
</template>

<script>
import axiosInstance from "../../helpers/axios.js";
import ErrorBlock from "@/components/Global/ErrorBlock.vue";
import SuccessBlock from "@/components/Global/SuccessBlock.vue";
import {mapGetters} from "vuex";

export default {
  name: "resend-email-verification",
  components: {SuccessBlock, ErrorBlock},
  data() {
    return {
      isLoading: false,
      requestError: {
        show: false,
        message: "",
      },
      requestSuccess: false,
      isResendDisabled: false,
      timer: 60,
    };
  },
  methods: {
    async submit() {
      if (!this.isResendDisabled) {
        try {
          this.isLoading = true;
          localStorage.setItem('token', this.token);
          await axiosInstance.get("/sendEmailVerificationLink");
          localStorage.removeItem('token')
          // Hiding the request error in case it was true before.
          this.requestError.show = this.requestError.show === true && false;
          this.requestSuccess = true;
          this.startCooldown();
        } catch (e) {
          // Showing requestErrorBlock in case there is any request errors.
          this.requestError.show = true;
          // Showing requestErrorBlock with a specific error message.
          if (
              e.response &&
              e.response.data &&
              e.response.data.message !== undefined
          ) {
            this.requestError.message = e.response.data.message;
          }
        } finally {
          this.isLoading = false;
        }
      }
    },
    startCooldown() {
      this.isResendDisabled = true;
      this.timer = 60;
      const interval = setInterval(() => {
        this.timer--;
        if (this.timer === 0) {
          clearInterval(interval);
          this.isResendDisabled = false;
        }
      }, 1000);
    },
  },
  computed: {
    cooldownTime() {
      return this.timer > 9 ? `0:${this.timer}` : `0:0${this.timer}`;
    },
    ...mapGetters({
      token: 'user/getToken'
    })
  },
};
</script>

<style>
</style>
